import React from 'react';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import CardContent from '@mui/material/CardContent';
import Skeleton from '@mui/material/Skeleton';

export default function UserProfileCard() {
  return (
    <>
      <Grid item xs={12}>
        <Skeleton animation="wave" height={30} style={{ marginBottom: 10, width: 170 }}/>
        <Skeleton animation="wave" height={20} style={{ marginBottom: 5, width: 120  }}/>
      </Grid>
      <Grid item xs={12} sm={6} md={6} xl={6}>
        <Skeleton animation="wave" height={60} width="100%" />
      </Grid>
      <Grid item xs={12} sm={6} md={6} xl={6}>
        <Skeleton animation="wave" height={60} width="100%" />
      </Grid>
      <Grid item xs={12}>
        <Skeleton animation="wave" style={{ width: 300 }} height={30} width="100%" />
      </Grid>
      <Grid item xs={12}>
      <Skeleton animation="wave" style={{ width: 300 }} height={30} width="100%" />
      </Grid>
      <Grid item xs={12}>
      <Skeleton animation="wave" style={{ width: 300 }} height={30} width="100%" />
      </Grid>
      <Grid item xs={12} sm={6} md={6} xl={6}>
        <Skeleton animation="wave" height={60} width="100%" />
      </Grid>
      <Grid item xs={12} sm={6} md={6} xl={6}>
        <Skeleton animation="wave" height={60} width="100%" />
      </Grid>
      <Grid item xs={12} sm={6} md={6} xl={6}>
        <Skeleton animation="wave" height={60} width="100%" />
      </Grid>
      <Grid item xs={12} sm={6} md={6} xl={6}>
        <Skeleton animation="wave" height={60} width="100%" />
      </Grid>
      <Grid item xs={12} sm={6} md={6} xl={6}>
        <Skeleton animation="wave" height={60} width="100%" />
      </Grid>
      <Grid item xs={12} sm={6} md={6} xl={6}>
        <Skeleton animation="wave" height={60} width="100%" />
      </Grid>
    </>
  );
}

